import { ConditionTypeEnum } from '.'

export interface IBooleanCondition {
  /**
   * The values needed to evaluate the condition
   */
  comparison: {
    /**
     * The operator to evaluate the condition, e.g. (true, false)
     */
    operator: BooleanOperatorEnum
  }
  /**
   * The field name associated with the condition, e.g. ('podReceived')
   */
  conditionName: string
  /**
   * The type of condition
   */
  conditionType: ConditionTypeEnum.Boolean
}

/**
 * The operator values for the boolean condition enum
 */
export enum BooleanOperatorEnum {
  FALSE = 'false',
  FALSY = 'falsy',
  TRUE = 'true'
}
